import React, { useState, useEffect, useContext } from 'react';
import './styles/HomePage.css';
import moment from 'moment';
import api from '../utils/api'; // Adjust this to your API handler location
import { useNavigate } from 'react-router-dom'; 
import AuthContext from '../context/AuthContext';

const HomePage = () => {
    const [birthdayStudents, setBirthdayStudents] = useState([]);
    const [birthdayTeachers, setBirthdayTeachers] = useState([]);
    const [studentBuckets, setStudentBuckets] = useState([]);
    const [dueDateStudents, setDueDateStudents] = useState([]);
    const [extraTimeRequests, setExtraTimeRequests] = useState([]);
    const [bookRequests, setBookRequests] = useState([]);
    const [teacherLeaveRequests, setTeacherLeaveRequests] = useState([]);
    const [teacherLeaveStatuses, setTeacherLeaveStatuses] = useState([]);
    const [studentLevelupRequests, setStudentLevelupRequests] = useState([]);
    const [studentLevelupApproveRequests, setStudentLevelupApproveRequests] = useState([]);
    const today = moment().format('YYYY-MM-DD');
    const navigate = useNavigate();
    const { user, permissions } = useContext(AuthContext); 
    const [teacher, setTeacher] = useState('');
    const [branchId, setBranchId] = useState(null);


    useEffect(() => {

        const fetchTeacher = async () => {
            try {
                const response = await api.post('/teacher/extratime/getTeacher', 
                    {
                        data: {
                            username: user.username
                        }
                    }
                );
                const teacherData = response.data.data;
                setTeacher(teacherData);
            } catch (error) {
                console.error("Failed to fetch teacher data", error);
            }
        };
        
        fetchTeacher();

    }, []);

    useEffect(() => {
        setBranchId(teacher.branch_id);
    }, [teacher]);

    useEffect(() => {
        if (permissions.some(p => p.permission_name === 'BIRTH_DAY_DASHBOARD')) {
            api.get('/student/birthday')
                .then(response => setBirthdayStudents(response.data))
                .catch(error => console.error('Error fetching birthday students:', error));
        }

        if (permissions.some(p => p.permission_name === 'TEACHER_BIRTH_DAY_DASHBOARD')) {
            api.get('/teacher/birthday')
                .then(response => setBirthdayTeachers(response.data))
                .catch(error => console.error('Error fetching birthday teacher:', error));
        }

        if (permissions.some(p => p.permission_name === 'BOOK_HANDOVER_DASHBOARD')) {
            api.post('/student/getStudentBucketList', {
                data: [{
                    branch_id: branchId,
                }]
            })
                .then(response => setStudentBuckets(response.data.data.bucketList))
                .catch(error => console.error('Error fetching birthday teacher:', error));
        }
        
        if (permissions.some(p => p.permission_name === 'DUE_DATE_DASHBOARD')) {
            api.get('/student/due-date')
                .then(response => setDueDateStudents(response.data))
                .catch(error => console.error('Error fetching due date students:', error));
        }
       
        
        if (permissions.some(p => p.permission_name === 'WAITING_APPROVAL_EXTRA_TIME_DASHBOARD')) {
            api.post('/teacher/extratime/list')
                .then(response => setExtraTimeRequests(response.data.data.extraTimeList))
                .catch(error => console.error('Error fetching due date students:', error));
        }
        
        if (permissions.some(p => p.permission_name === 'INVENTORY_BOOK_REQUEST_DASHBOARD')) {
            api.get('/inventory/getBookRequests')
                .then(response => setBookRequests(response.data.data.bookRequestList))
                .catch(error => console.error('Error fetching due date students:', error));
        }


        if (permissions.some(p => p.permission_name === 'WAITING_APPROVAL_LEAVE_DASHBOARD')) {
            api.post('/teacher/leave/list')
                .then(response => setTeacherLeaveRequests(response.data.data.teacherLeaveList))
                .catch(error => console.error('Error fetching due date students:', error));
        }
        

        if (permissions.some(p => p.permission_name === 'LEAVE_STATUS_DASHBOARD')) {
            api.post('/teacher/leave/statuslist')
                .then(response => setTeacherLeaveStatuses(response.data.data.teacherLeaveList))
                .catch(error => console.error('Error fetching due date students:', error));
        }
        

        if (permissions.some(p => p.permission_name === 'WAITING_APPROVAL_STUDENT_LEVEL_UP_DASHBOARD')) {
            api.post('/student/levelup/list')
                .then(response => setStudentLevelupRequests(response.data.data.studentLevelupList))
                .catch(error => console.error('Error fetching due date students:', error));
        }
        

        if (permissions.some(p => p.permission_name === 'WAITING_PAYMENT_STUDENT_LEVEL_UP_DASHBOARD')) {
            api.post('/student/levelup/approveList')
                .then(response => setStudentLevelupApproveRequests(response.data.data.studentLevelupList))
                .catch(error => console.error('Error fetching due date students:', error));
        }
    }, [branchId]);

    const handleExtraTime = (extraTimeId) => {
        navigate(`/teacher/extraTime/detail/${extraTimeId}`);
    };

    const handleBookRequest = (bookRequestId) => {
        navigate(`/inventory/bookRequest/detail/${bookRequestId}`);
    };

    const handleLeave = (teacherLeaveId) => {
        navigate(`/teacher/leave/detail/${teacherLeaveId}`);
    };

    
    const handleLevelup = (levelupRequestId) => {
        navigate(`/student/levelup/detail/${levelupRequestId}`);
    };

    
    const handleLevelupApprove = (levelupRequestId) => {
        navigate(`/student/levelup/approveDetail/${levelupRequestId}`);
    };

    const handleBookHandover = (bucketId) => {
        navigate(`/student/bucket/detail/${bucketId}`);
    };

    const handleSppPayment = (studentId) => {
        navigate(`/spp-payment-details/${studentId}`);
    };

    return (
        <div className="home-page">
            {permissions.some(p => p.permission_name === 'BIRTH_DAY_DASHBOARD') && (
            <div className="section">
                <div className="page-title">Student Birthday List</div>
                <table className="dashboard-table">
                    <thead>
                        <tr>
                            <th>Name</th>
                            <th>Branch</th>
                            <th>Birth Date</th>
                        </tr>
                    </thead>
                    <tbody>
                        {birthdayStudents.map(student => (
                            <tr key={student.student_id} className={moment(student.birth_date).format('MM-DD') === moment(today).format('MM-DD') ? 'highlight' : ''}>
                                <td>{student.student_name}</td>
                                <td>{student.Branch.branch_name}</td>
                                <td>{moment(student.birth_date).format('DD MMMM YYYY')}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
            )}
            {permissions.some(p => p.permission_name === 'TEACHER_BIRTH_DAY_DASHBOARD') && (
            <div className="section">
                <div className="page-title">Teacher Birthday List</div>
                <table className="dashboard-table">
                    <thead>
                        <tr>
                            <th>Name</th>
                            <th>Branch</th>
                            <th>Birth Date</th>
                        </tr>
                    </thead>
                    <tbody>
                        {birthdayTeachers.map(teacher => (
                            <tr key={teacher.teacher_id} className={moment(teacher.birth_date).format('MM-DD') === moment(today).format('MM-DD') ? 'highlight' : ''}>
                                <td>{teacher.teacher_name}</td>
                                <td>{teacher.Branch? teacher.Branch.branch_name : 'Central'}</td>
                                <td>{moment(teacher.birth_date).format('DD MMMM YYYY')}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
            )}
            {permissions.some(p => p.permission_name === 'BOOK_HANDOVER_DASHBOARD') && (
            <div className="section">
                <div className="page-title">Book Handover List</div>
                <div className="students-list">
                    <table>
                        <thead>
                            <tr>
                                <th class="no-column">No</th>
                                <th>Student Name</th>
                                <th>NIK</th>
                                <th>Branch</th>
                                <th>Program</th>
                                <th>Join Date</th>
                            </tr>
                        </thead>
                        <tbody>
                            {studentBuckets.map((bucket, index) => (
                                <tr key={bucket.bucket_id} onClick={() => handleBookHandover(bucket.bucket_id)}>
                                    <td class="no-column">{index + 1}</td>
                                    <td>{bucket.Student.student_name}</td>
                                    <td>{bucket.Student.student_code}</td>
                                    <td>{bucket.Student.Branch.branch_name}</td>
                                    <td>{bucket.Student.StudentLevels.map(level => level.mainProgram.program_name).join(', ')}</td>
                                    <td>{moment(bucket.Student.join_date).format('DD MMMM YYYY')}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </div>
            )}
            {permissions.some(p => p.permission_name === 'DUE_DATE_DASHBOARD') && (
            <div className="section">
                <div className="page-title">Student Due Date List</div>
                <table className="dashboard-table">
                    <thead>
                        <tr>
                            <th class="no-column">No</th>
                            <th>Name</th>
                            <th>Branch</th>
                            <th>Status</th>
                            <th>Due Month</th>
                        </tr>
                    </thead>
                    <tbody>
                        {dueDateStudents.map((student, index) => (
                            <tr key={student.student_id} onClick={() => handleSppPayment(student.student_id)}>
                                <td class="no-column">{index+1}</td>
                                <td>{student.student_name}</td>
                                <td>{student.Branch.branch_name}</td>
                                <td>{student.StudentStatuses[0].Status.status_name}</td>
                                <td>{moment().month(student.Payments[0].StudentPaymentHistories[0].payment_month).year(student.Payments[0].StudentPaymentHistories[0].payment_year).format('MMMM YYYY')}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
            )}
            {permissions.some(p => p.permission_name === 'WAITING_APPROVAL_EXTRA_TIME_DASHBOARD') && (
            <div className="section">
                <div className="page-title">Extra Time Request List</div>
                <table className="dashboard-table">
                    <thead>
                        <tr>
                            <th class="no-column">No</th>
                            <th>Teacher Name</th>
                            <th>Branch</th>
                            <th>Request Type</th>
                            <th>Status</th>
                            <th>Extra Time Date</th>
                            <th>Requested On</th>
                        </tr>
                    </thead>
                    <tbody>
                        {extraTimeRequests.map((extraTime, index) => (
                            <tr key={extraTime.extra_time_id} onClick={() => handleExtraTime(extraTime.extra_time_id)}>
                                <td class="no-column">{index+1}</td>
                                <td>{extraTime.Teacher.teacher_name}</td>
                                <td>{extraTime.Teacher.Branch? extraTime.Teacher.Branch.branch_name : 'Central'}</td>
                                <td>{extraTime.Type ? extraTime.Type.type : ""} - {extraTime.Type ? extraTime.Type.type_name : ""}</td>
                                <td>{extraTime.Status.status_name}</td>
                                <td>{moment(extraTime.extra_time_date).format('DD MMMM YYYY')}</td>
                                <td>{moment(extraTime.requested_on).format('DD MMMM YYYY')}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
            )}
            {permissions.some(p => p.permission_name === 'INVENTORY_BOOK_REQUEST_DASHBOARD') && (
            <div className="section">
                <div className="page-title">Book Request List</div>
                <table className="dashboard-table">
                    <thead>
                        <tr>
                            <th class="no-column">No</th>
                            <th>Teacher Name</th>
                            <th>Branch</th>
                            <th>Status</th>
                            <th>Requested On</th>
                        </tr>
                    </thead>
                    <tbody>
                        {bookRequests.map((bookRequest, index) => (
                            <tr key={bookRequest.book_request_id} onClick={() => handleBookRequest(bookRequest.book_request_id)}>
                                <td class="no-column">{index+1}</td>
                                <td>{bookRequest.Teacher.teacher_name}</td>
                                <td>{bookRequest.Teacher.Branch? bookRequest.Teacher.Branch.branch_name : 'Central'}</td>
                                <td>{bookRequest.Status.status_name}</td>
                                <td>{moment(bookRequest.requested_on).format('DD MMMM YYYY')}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
            )}
            {permissions.some(p => p.permission_name === 'WAITING_APPROVAL_LEAVE_DASHBOARD') && (
            <div className="section">
                <div className="page-title">Teacher Leave Request List</div>
                <table className="dashboard-table">
                    <thead>
                        <tr>
                            <th class="no-column">No</th>
                            <th>Teacher Name</th>
                            <th>Branch</th>
                            <th>Status</th>
                            <th>Leave Date</th>
                            <th>Requested On</th>
                        </tr>
                    </thead>
                    <tbody>
                        {teacherLeaveRequests.map((teacherLeave, index) => (
                            <tr key={teacherLeave.teacher_leave_id} onClick={() => handleLeave(teacherLeave.teacher_leave_id)}>
                                <td class="no-column">{index+1}</td>
                                <td>{teacherLeave.Teacher.teacher_name}</td>
                                <td>{teacherLeave.Teacher.Branch ? teacherLeave.Teacher.Branch.branch_name : 'CENTRAL'}</td>
                                <td>{teacherLeave.Status.status_name}</td>
                                <td>{moment(teacherLeave.leave_date).format('DD MMMM YYYY')}</td>
                                <td>{moment(teacherLeave.requested_on).format('DD MMMM YYYY')}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
            )}
            {permissions.some(p => p.permission_name === 'LEAVE_STATUS_DASHBOARD') && (
            <div className="section">
                <div className="page-title">Teacher Leave Status List</div>
                <table className="dashboard-table">
                    <thead>
                        <tr>
                            <th class="no-column">No</th>
                            <th>Teacher Name</th>
                            <th>Branch</th>
                            <th>Leave Date</th>
                            <th>Status</th>
                        </tr>
                    </thead>
                    <tbody>
                        {teacherLeaveStatuses.map((teacherLeave, index) => (
                            <tr key={teacherLeave.teacher_leave_id} onClick={() => handleLeave(teacherLeave.teacher_leave_id)}>
                                <td class="no-column">{index+1}</td>
                                <td>{teacherLeave.Teacher.teacher_name}</td>
                                <td>{teacherLeave.Teacher.Branch ? teacherLeave.Teacher.Branch.branch_name : 'CENTRAL'}</td>
                                <td>{moment(teacherLeave.leave_date).format('DD MMMM YYYY')}</td>
                                <td>{teacherLeave.Status.status_name}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
            )}
            {permissions.some(p => p.permission_name === 'WAITING_APPROVAL_STUDENT_LEVEL_UP_DASHBOARD') && (
            <div className="section">
                <div className="page-title">Student Level Up Request List</div>
                <table className="dashboard-table">
                    <thead>
                        <tr>
                            <th class="no-column">No</th>
                            <th>Student Name</th>
                            <th>Teacher Name</th>
                            <th>Branch</th>
                            <th>Request On</th>
                            <th>Status</th>
                        </tr>
                    </thead>
                    <tbody>
                        {studentLevelupRequests.map((levelup, index) => (
                            <tr key={levelup.student_levelup_request_id} onClick={() => handleLevelup(levelup.student_levelup_request_id)}>
                                <td class="no-column">{index+1}</td>
                                <td>{levelup.Student.student_name}</td>
                                <td>{levelup.Teacher.teacher_name}</td>
                                <td>{levelup.Teacher.Branch.branch_name}</td>
                                <td>{moment(levelup.requested_on).format('DD MMMM YYYY')}</td>
                                <td>{levelup.Status.status_name}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
            )}
            {permissions.some(p => p.permission_name === 'WAITING_PAYMENT_STUDENT_LEVEL_UP_DASHBOARD') && (
            <div className="section">
                <div className="page-title">Student Level Up Waiting for Payment List</div>
                <table className="dashboard-table">
                    <thead>
                        <tr>
                            <th class="no-column">No</th>
                            <th>Student Name</th>
                            <th>Teacher Name</th>
                            <th>Branch</th>
                            <th>Approve On</th>
                            <th>Status</th>
                        </tr>
                    </thead>
                    <tbody>
                        {studentLevelupApproveRequests.map((levelup, index) => (
                            <tr key={levelup.student_levelup_request_id} onClick={() => handleLevelupApprove(levelup.student_levelup_request_id)}>
                                <td class="no-column">{index+1}</td>
                                <td>{levelup.Student.student_name}</td>
                                <td>{levelup.Teacher.teacher_name}</td>
                                <td>{levelup.Teacher.Branch.branch_name}</td>
                                <td>{moment(levelup.approved_on).format('DD MMMM YYYY')}</td>
                                <td>{levelup.Status.status_name}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
            )}
        </div>
    );
};

export default HomePage;
